import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const FadeUpRollover = styled.div`
  opacity: 0.4;
  transition: opacity 200ms;

  &:hover {
    opacity: ${() => {
      if (!isTouch()) {
        return "1";
      }
    }};
  }
`;

export default FadeUpRollover;
